module.exports = __webpack_public_path__ + "static/media/default-prospect-photo.a9c736d4.png";